<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
/* eslint-disable */
// // pass all the custom pcsser';
//
// const config = {
//   color: 'palevioletred', // color of the outline
//   width: '4px', // width of the outline
//   grayscaleOnDebugAll: true, // apply grayscale filter to every element
//   customClass: 'exampleClass' // a class existent in your stylesheet
// };

// init the debugger
// const debug = new Debucsser(config).init();
export default {
  name: 'App'
};
</script>

<style lang='scss'>
#app {
	font-family: sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
	margin: 0 auto;
}
</style>
